export const CONFIG = {
  withSentry: false,
  withTranslations: true,
}

export const API_BASE = 'https://app.hazziapp.net/api/v1/'
export const SENTRY_DSN = 'https://<sentry-id>@sentry.io/<sentry-sub-id>'
export const GA_CODE = 'UA-<google-analytics-id>-1'
export const FIREBASE = {
  apiKey: '<api-key>',
  authDomain: '<project-id>.firebaseapp.com',
  databaseURL: 'https://<project-id>.firebaseio.com',
  projectId: '<project-id>',
  storageBucket: '<project-id>.appspot.com',
  messagingSenderId: '<messaging-sender-id>',
  appId: '1:<messaging-sender-id>:web:<token>',
  measurementId: 'G-<measurement-id>',
}
export const STRIPE = {
  PK: 'pk_live_51GsZmzCW2OsmyExCK30TtjIofskomxLF2esTjOTR9is7JtSaJQJMOyOhuXBVbr3SZiMfy1XHJHSaKLc8bak1luCT00QFe4qPFx',
}
